app.directive("quillViewer", ["Base64", function (Base64) {
    return {
        restrict: "A",
        scope: {
            content: "="
        },
        link: function (scope, element, attrs) {
            element.addClass('quill-viewer-container');

            const options = {
                theme: 'snow',
                readOnly: true,
                modules: {
                    toolbar: false
                },
            };

            const quill = new Quill(element[0], options);

            scope.$watch('content', function (newContent) {
                if (newContent) {
                    const decodedHtml = Base64.decode(newContent);

                    quill.clipboard.dangerouslyPasteHTML(decodedHtml);
                } else {
                    quill.setText('');
                }
            });
        }
    };
}]);